import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../../api';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ICoursesForSubscriptions, ICourseStudent } from '.';

export type TUpdateCourseStudentLearningDetails = {
  courseStudentId: string;
  subjectExperienceLevel?: string;
  // learningStyle?: string;
  // upcomingExamStatus?: string;
  // otherRequirement?: string;
  lastExamStatus?: string;
  currentGrade?: string;
  targetGrade?: string;
  upcomingExamDate?: string;
  specialRequirement?: string;
  specificTopic?: string;
};

const apiDataProvider = new APIDataProvider();

export const getCoursesByUser = createAsyncThunk(
  '/course-students/getCoursesByUser',
  async () => {
    const path = `${ApiPaths.courseStudents}/status`;

    const response = await apiDataProvider.get<
      TApiResponse<ICoursesForSubscriptions>
    >(path);

    return response.data;
  }
);

export const getCourseStudentsByCourseId = createAsyncThunk(
  '/course-students/getCourseStudentsByCourseId',
  async (id: string) => {
    const path = `${ApiPaths.courseStudents}/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<Array<ICourseStudent>>
    >(path);

    return response.data;
  }
);

export const getCourseStudentsByUser = createAsyncThunk(
  '/course-students/getCourseStudentsByUser',
  async (id: string) => {
    const path = `${ApiPaths.courseStudents}/student/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<Array<ICourseStudent>>
    >(path);

    return response.data;
  }
);

export const updateCourseStudentLearningDetails = createAsyncThunk(
  '/course-students/update-learning-details',
  async (data: TUpdateCourseStudentLearningDetails) => {
    const path = `${ApiPaths.courseStudents}/learning-details`;

    const response = await apiDataProvider.put<TApiResponse<ICourseStudent>>(
      path,
      data
    );

    return response.data;
  }
);
